import React from 'react';
import styled from "styled-components";
import {useAtom} from "jotai";
import {modalState} from "../../../states/action";


/**
 팝업 헤더

 * @param data1 설명
 * @return {data1} 반환
 * @throws ValidException 예외 발생
 * @author plaq99@rumpus.co.kr
 * @date 03-20-2023
 */

export default function ModalHeader() {

  const [{modalTitle}, setModalOn] = useAtom(modalState)

  return (
    <>
      <ModalHeaderArea>
        {modalTitle}
        <button
          type="button"
          className="btn_close"
          title="닫기"
          onClick={() => setModalOn((prev) => ({...prev, modalOn: false}))}
        >
          <i className="bi bi-x-lg"></i>
          <span className="hide">닫기</span>
        </button>
      </ModalHeaderArea>
    </>
  );
}


const ModalHeaderArea = styled.div`
  padding: 0 20px;
  font-size: 17px;
  font-weight: bold;
  color: #fff;
  line-height: 50px;

  .btn_close {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    font-size: 20px;
  }
`;
